const language = {
    ENGLISH: "english",
    FRENCH: "french",
    isEnglish: function(lang) {
        if(lang === undefined || lang === this.ENGLISH) {
            return true;
        } else if(lang === this.FRENCH) {
            return false;
        } else {
            throw new Error("invalid language");
        }
    },
    validate: function(lang) {
        if(lang !== undefined && lang !== this.ENGLISH && lang !== this.FRENCH) {
            throw new Error("invalid language");
        }
    },
}

export default language;


// WEBPACK FOOTER //
// ./src/modules/Language.js